class Training2ViewModel {
    constructor(params: any) {
    }
}

export default { viewModel: Training2ViewModel, template: require('./training2.html') };